module.exports = __webpack_public_path__ + "static/img/detail_bg.0da09b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/detail_bg.png
// module id = KzIa
// module chunks = 1